import type { CameraConfig } from '../types';

export * from './widgetGroups';

export const MODEL_FORMATS = ['glb', 'gltf', 'fbx', 'obj', 'ply', 'stl'] as const;

export const COMPONENT_TYPES = [
  'indicator',
  'line-chart',
  'bar-chart',
  'pie-chart',
  'table',
  'ranking',
  'heatmap',
  'map-scatter',
  'gauge',
  'text',
  'image',
  'video',
] as const;

export const USER_ROLES = ['admin', 'editor', 'viewer'] as const;

export const DATA_SOURCE_TYPES = ['static', 'api', 'websocket', 'sql', 'mqtt'] as const;

export const DEFAULT_PAGE_SIZE = { width: 1920, height: 1080 };

export const DEFAULT_CAMERA: CameraConfig = {
  position: [10, 10, 10],
  target: [0, 0, 0],
  fov: 60,
  near: 0.1,
  far: 1000,
};

export const API_PREFIX = '/api/v1';

export const DEFAULT_BASEMAP_URLS = {
  osm: '/osm-tiles/{z}/{x}/{y}.png',
  // 2026-09-01｜去商业授权源：原 Esri ArcGIS / Carto 需商业授权，全部替换为高德瓦片（免 key，已授权）
  arcgis_imagery: 'https://webst01.is.autonavi.com/appmaptile?style=6&x={x}&y={y}&z={z}',
  arcgis_street: 'https://webrd01.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=8&x={x}&y={y}&z={z}',
  arcgis_topo: 'https://webrd01.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=8&x={x}&y={y}&z={z}',
  carto_light: 'https://webst01.is.autonavi.com/appmaptile?style=6&x={x}&y={y}&z={z}',
  carto_dark: 'https://webrd01.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=8&x={x}&y={y}&z={z}',
} as const;

// ============================================================
// 授权底图模板（天地图/高德，密钥不入库，由前端环境变量注入）
// 密钥配置见 docs/地图/地图秘钥.md；{tk} 占位符由前端替换
// ============================================================

export const TIANDITU_TEMPLATES = {
  // 矢量地图（vec）
  vec: 'https://t0.tianditu.gov.cn/vec_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=vec&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk={tk}',
  // 卫星影像（img）
  img: 'https://t0.tianditu.gov.cn/img_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk={tk}',
  // 影像注记（cia，需叠加在 img 之上）
  cia: 'https://t0.tianditu.gov.cn/cia_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=cia&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk={tk}',
} as const;

export const AMAP_TEMPLATES = {
  // 高德街道（webrd01 固定子域，瓦片无需 key）
  street: 'https://webrd01.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=8&x={x}&y={y}&z={z}',
  // 高德卫星影像（webst01 固定子域）
  img: 'https://webst01.is.autonavi.com/appmaptile?style=6&x={x}&y={y}&z={z}',
} as const;
